import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpService {
    private readonly http = inject(HttpClient);
    private readonly config = inject(ConfigService);

    patch(slug: string[]): Observable<any> {
        return this.http.patch<any>(
            `${this.config.getConfiguration().API_BASE}/${slug.join('/')}`,
            {}
        );
    }
}
